import { useSettingsValueData } from "../../app/hooks/useSettingsValueData";
import { parseCookie } from "../../payment/miscellaneous/parseCookie";

export function getCustomThankYouPageDetails() {
  const { data: partnerSettingsData } = useSettingsValueData();
  const thankYouPages = partnerSettingsData?.customThankYouPages;
  const currentDomain: string = window.location.hostname;
  const partnerDomainCookie: string | undefined = parseCookie(document.cookie)["MkHcPartnerOriginDomain"]?.toLowerCase();
  const languageCookie: string | undefined = parseCookie(document.cookie)["MkHcLang"]?.toLowerCase();

  const mappingDomain = partnerDomainCookie ?? currentDomain;
  const getCustomThankYouUrl = (): string | undefined => {
    if (
      thankYouPages?.mappingCombination === "isoLanguage" &&
      thankYouPages?.isoLanguageUrlMappings
    ) {
      for (const domainMapping of thankYouPages.isoLanguageUrlMappings) {
        if (domainMapping.domain === mappingDomain && domainMapping.urlMappings) {
          const match = domainMapping.urlMappings.find(
            (urlMapping) => urlMapping.urlKey?.toLowerCase() === languageCookie
          );
          return match?.urlValue;
        }
      }
    }
    return undefined;
  };

  const redirectionUrl: string | undefined = getCustomThankYouUrl();
  const allowRedirection: boolean = Boolean(thankYouPages?.isRedirectionAllowed && redirectionUrl);

  return {
    allowRedirection,
    redirectionUrl
  };
}